import { navigate } from 'svelte-routing';
import { DadosPaginaAnterior } from './Stores';

class Navigate {
  constructor(parametro) {
    this.parametro = parametro;
    this.goTo(this.parametro);
  }

  goTo(parametro) 
  {
    // Armazena o caminho completo da página atual antes de navegar
    DadosPaginaAnterior.update(store => {
      store.pagina = window.location.pathname + window.location.search;
      return store;
    });
    
    console.log("navegando");
    
    // Faz a navegação para a nova página
    navigate(parametro);
  }
}

export default Navigate;
